import React, { useRef, useState } from "react";
import DataTable from "datatables.net-react";
import DT from "datatables.net-dt";
import { getMediaChunkText } from "../../services/media";
import { escapeHtml, normalizeChunks } from "../../utils/mediaChunks";

DataTable.use(DT);

const MediaChunksTable = ({ mediaChunks, emptyMessage = "No chunks were returned for this item." }) => {
  const tableRef = useRef();
  const [showChunkText, setShowChunkText] = useState(false);
  const [sourceChunkText, setSourceChunkText] = useState("");
  const [chunkText, setChunkText] = useState("");

  const chunks = normalizeChunks(mediaChunks);

  // Only the id goes through inline: chunk text is arbitrary document content and would
  // otherwise be injected into an HTML attribute, breaking the row on any apostrophe.
  window.viewSourceMediaChunk = async (sourceMediaChunkId) => {
    setSourceChunkText("Loading Chunk Text...");
    setShowChunkText(true);
    const result = await getMediaChunkText(sourceMediaChunkId);
    if (result?.success) {
      setSourceChunkText(result.text ?? "");
      setChunkText(result.text ?? "");
    } else {
      setSourceChunkText(result?.message || "Could not load the source chunk.");
    }
  };

  const tableData = chunks.map((chunk) => {
    const fieldValues = {
      public_id: escapeHtml(chunk.id),
      text: `<div style="display: -webkit-box; -webkit-box-orient: vertical; -webkit-line-clamp: 3; overflow-y: auto; overflow-x: hidden;">${escapeHtml(chunk.text)}</div>`,
      view_source_chunk: `<div style="text-decoration: underline; cursor: pointer;" onclick="window.viewSourceMediaChunk('${escapeHtml(chunk.sourceId)}')">View Source Chunk</div>`,
    };

    return [
      fieldValues.public_id,
      fieldValues.text,
      chunk.sourceId ? fieldValues.view_source_chunk : ""
    ];
  });

  return (
    <div style={{ width: "100%", position: "relative", paddingLeft: "20px", paddingRight: "20px" }}>
      {chunks.length === 0 ? (
        <div style={{ padding: "16px", fontSize: "14px", fontStyle: "italic", color: "#a0a6b1", border: "1px dashed var(--main-border-color)", borderRadius: "8px" }}>
          {emptyMessage}
        </div>
      ) : (
        <DataTable
          ref={tableRef}
          data={tableData}
          className="display"
          options={{
            responsive: true,
            select: true,
            pageLength: 25,
            ordering: false,
          }}
        >
          <thead>
            <tr>
              <th>ID</th>
              <th style={{ minWidth: "200px" }}>Chunk Text</th>
              <th style={{ minWidth: "200px" }}>Actions</th>
            </tr>
          </thead>
        </DataTable>
      )}

      {
        showChunkText ? (
          <div style={{ position: "fixed", top: "50%", left: "50%", transform: "translate3d(-50%, -50%, 0)", backgroundColor: "var(--dialog-bg)", boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)", borderRadius: "8px", borderWidth: "1px", borderStyle: "solid", borderColor: "var(--chat-bubble-font-color)", padding: "20px", overflow: "hidden", width: "800px", height: "600px", zIndex: 2000000000 }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "20px" }}>
              <div>
                <div style={{ fontSize: "20px", fontWeight: "bold" }}>Source Media Chunk Text</div>
                <div style={{ fontSize: "18px" }}>{chunkText.substring(0, 100)}</div>
              </div>
              <button onClick={() => setShowChunkText(false)} style={{ padding: "8px 16px", fontSize: "16px", cursor: "pointer" }}>Close</button>
            </div>
            <div style={{ whiteSpace: "pre-wrap", overflow: "auto", height: "400px" }}>{sourceChunkText}</div>
          </div>
        ) : null
      }
    </div >
  );
};

export default MediaChunksTable;
